import script from "./FeedBack.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedBack.vue?vue&type=script&setup=true&lang=js"

import "./FeedBack.vue?vue&type=style&index=0&id=effb650e&lang=less"

const __exports__ = script;

export default __exports__